import newAccount from './newAccount.js';
import User from './user.js';
import {storage, events} from '@nuskin/ns-util';

/**
 *
 * UserCookieBaseService
 *
 * @namespace UserCookieBaseService
 */
newAccount.UserCookieBaseService = function (STORAGE_KEY) {
    "use strict";

    let IS_LOGGED_IN = "loggedIn";

    let publicMethods = {
        isLoggedIn: isNativeMobile() ? isLoggedInNative : isLoggedIn,
        setLoggedIn: isNativeMobile() ? setLoggedInNative : setLoggedIn,
        getUser: getUser,
        setUser: setUser,
        resetUserStorage: resetUserStorage,
        getStoredUser: getStoredUser,
        writeUserToStorage: writeUserToStorage
    };


    // PUBLIC API,

    /**
     * @memberof UserCookieBaseService
     * @example
     * UserCookieBaseService.isLoggedIn()
     * @returns {boolean}
     */
    function isLoggedIn() {
        let loggedIn = $.cookie(IS_LOGGED_IN);
        return (loggedIn != null && loggedIn != "null");
    }

    /**
     * @memberof UserCookieBaseService
     * @example
     * UserCookieBaseService.isLoggedInNative()
     * @returns {boolean}
     */
    function isLoggedInNative() {
        return sessionStorage.getItem(IS_LOGGED_IN) != null;
    }

    /**
     * @memberof UserCookieBaseService
     * @example
     * UserCookieBaseService.setLoggedIn(val)
     * @param val
     */
    function setLoggedIn(val) {
        if (val) {
            //            var expires = new Date();
            //            expires.setTime(expires.getTime() + LOGIN_PERIOD);
            //            $.cookie(IS_LOGGED_IN, "true", {path: "/", expires: expires});
            // AEM-8126 make sure the loggedIn is false when the browser is closed
            // Make it as a session cookie
            let oldValue = $.cookie(IS_LOGGED_IN);
            $.cookie(IS_LOGGED_IN, "true", {path: "/"});

            if (oldValue !== "true") {
                events.setValue(events.authentication.LOGIN);
            }
        }
        else {
            $.cookie(IS_LOGGED_IN, null, {path: "/"});
            events.setValue(events.authentication.LOGIN);
        }

        // $.publish(events.authentication.LOGIN);
    }

    /**
     * @memberof UserCookieBaseService
     * @example
     * UserCookieBaseService.setLoggedInNative(y)
     * @param y
     */
    function setLoggedInNative(y) {
        if (y) {
            let oldValue = sessionStorage.getItem(IS_LOGGED_IN);
            sessionStorage.setItem(IS_LOGGED_IN, true);
            if (!oldValue) {
                events.setValue(events.authentication.LOGIN);
            }
        }
        else {
            sessionStorage.removeItem(IS_LOGGED_IN);
            events.setValue(events.authentication.LOGIN);
        }

        // $.publish(events.authentication.LOGIN);
    }

    /**
     * @memberof UserCookieBaseService
     * @example
     * UserCookieBaseService.getUser()
     * @returns {object} user
     */
    function getUser() {
        let user = null;
        let userData = getStoredUser();
        if (userData) {
            // if the user is really logged, then return the user
            if (publicMethods.isLoggedIn()) {
                user = User;
                user.init(userData);
            } else {
                // otherwise, we should just remove from the storage for cleanup
                resetUserStorage();
            }
        }
        return user;
    }

    /**
     * @memberof UserCookieBaseService
     * @example
     * UserCookieBaseService.setUser(user)
     * @param user
     */
    function setUser(user) {
        writeUserToStorage(user);
    }

    /**
     * @memberof UserCookieBaseService
     * @example
     * UserCookieBaseService.resetUserStorage()
     */
    function resetUserStorage() {
        writeUserToStorage(null);
        publicMethods.setLoggedIn(false);
    }


    // ---------------------------------------------
    //
    //        Define all methods for override.
    //
    // ---------------------------------------------

    /**
     * @memberof UserCookieBaseService
     * @example
     * UserCookieBaseService.getStoredUser()
     * @returns {object} user
     */
    function getStoredUser() {
        let user = null;
        let val = storage.getItem(STORAGE_KEY);
        if (val !== null && val !== undefined) {
            let account = val;
            if (account !== null && account !== undefined) {
                user = val.user;
            }
        }
        return user;
    }

    /**
     * @memberof UserCookieBaseService
     * @example
     * UserCookieBaseService.writeUserToStorage(user)
     * @param user
     */
    function writeUserToStorage(user) {
        if (user == null || typeof (user) == 'undefined') {
            storage.removeItem(STORAGE_KEY);
        } else if (user.instance === User.instance) {
            storage.setItem(STORAGE_KEY, {user: user.toJSON()});
        } else {
            storage.setItem(STORAGE_KEY, {user: user});
        }
    }

    // PRIVATE METHODS
    //nuskin.util is not loaded yet, so we are using a standalone function
    function isNativeMobile() {
        return (document.URL.indexOf("http://") === -1 && document.URL.indexOf("https://") === -1);
    }

    return publicMethods;
};

export default newAccount.UserCookieBaseService;
